import React, { useEffect, useState } from "react";
import { useAuthentication } from "../../context/authentication";
import { useHistory, Link } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  Badge,
  Container,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { SecondaryListItems } from "../../components/drawer";
import { Group, User } from "../../database";
import firebase from "firebase";
import "./index.css";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  fetchBooksByUser,
  fetchCummulativeData,
  fetchPreviousDayData,
} from "../../database/Book";
import moment from "moment";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";

const drawerWidth = 240;
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
const mothList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  addToUser: {
    marginBottom: 20,
  },
  userInfoContainer: {
    paddingLeft: 30,
  },
  table: {
    paddingLeft: 30,
    marginTop: 20,
  },
}));
const UsersScreen = () => {
  const { push } = useHistory();
  const { doLogout, user } = useAuthentication();
  const [books, setBooks] = useState([]);
  const [cummulativeData, setCummulativeData] = useState([]);
  const [previousDayData, setPreviousDayData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(moment().format("MMMM"));
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedBook, setSelectedBook] = useState(null);
  const [booksList, setBooksList] = useState([]);
  const [userData, setUserData] = useState(null);
  const classes = useStyles();

  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const logout = async () => {
    await doLogout();
    push("/login");
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchBooksByUser(user.email);
      const response1 = await fetchCummulativeData(user.email);
      if (response && response.data) {
        const sortedBooks = response.data.books.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );
        setBooks(sortedBooks);
        setUserData(response.data.userData);
        setBooksList(response.data.booksList);
        setSelectedBook(response.data.booksList[0]);
      }
      if (response1 && response1.data) {
        setCummulativeData(response1.data);
      }
    };
    if (user) {
      fetchData();
    }
  }, [user]);
  useEffect(() => {
    console.log(booksList);
  }, [booksList]);
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={clsx(classes.appBar, open && classes.appBarShift)}
        >
          <Toolbar className={classes.toolbar}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className={clsx(
                classes.menuButton,
                open && classes.menuButtonHidden
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Dashboard
            </Typography>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
          }}
          open={open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <List>
            <ListItem>
              <Link to="/account" style={{ color: "#000" }}>
                <ListItemIcon>
                  <ListItemIcon />
                </ListItemIcon>
                <ListItemText primary="Account" />
              </Link>
            </ListItem>
            <SecondaryListItems logout={logout} />
          </List>
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <div className={classes.userInfoContainer}>
              <Typography variant="h4" component="div" gutterBottom>
                Welcome, {userData?.data.name}
              </Typography>
              <Typography
                variant="h6"
                component="div"
                gutterBottom
                style={{ marginTop: "30px" }}
              >
                Earning Report (Excl. this month)
              </Typography>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Title</TableCell>

                      <TableCell>Lifetime Earnings-paperback</TableCell>
                      <TableCell>Lifetime Earnings-kindle</TableCell>
                      <TableCell>Paperback Total books sold</TableCell>
                      <TableCell>Kindle Total books sold</TableCell>
                      <TableCell>Author's Copy</TableCell>
                      <TableCell>Total books sold</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cummulativeData.map((row) => (
                      <TableRow key={row.name}>
                        <TableCell component="th" scope="row">
                          {row.title}
                        </TableCell>
                        <TableCell>
                          {row.lifeTimeEarningPaperBack
                            ? row.lifeTimeEarningPaperBack.toFixed(2)
                            : "0"}
                        </TableCell>
                        <TableCell>{row.lifeTimeEarningKindle}</TableCell>
                        <TableCell>{row.paperBackTotalBooksSold}</TableCell>
                        <TableCell>{row.kindleTotalBooksSold}</TableCell>
                        <TableCell>{row.authorCopy}</TableCell>
                        <TableCell>{row.grandTotal}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div style={{ marginTop: "20px", paddingLeft: "30px" }}>
              <div style={{ display: "flex" }}>
                <Typography
                  variant="h6"
                  component="div"
                  gutterBottom
                  style={{ marginTop: "30px", marginRight: "30px" }}
                >
                  {selectedMonth}'s Selling
                </Typography>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedBook}
                  onChange={(e) => setSelectedBook(e.target.value)}
                >
                  {booksList.map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </Select>
              </div>
              <TableContainer component={Paper} style={{ marginTop: 20 }}>
                <Table
                  className={`${classes.table} books-details`}
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>PB Profit Earning</TableCell>
                      <TableCell>eBook Profit Earning</TableCell>
                      <TableCell>Amazon</TableCell>
                      <TableCell>Flipkart</TableCell>
                      <TableCell>Nexus</TableCell>
                      <TableCell>PB Total Qty</TableCell>
                      {/* <TableCell>PB Profit Earnings</TableCell> */}
                      <TableCell>eBook Overseas</TableCell>
                      <TableCell>eBook National</TableCell>
                      <TableCell>eBook Total Qty</TableCell>
                      {/* <TableCell>eBook Profit Earnings</TableCell> */}
                      <TableCell>Grand Total Sales Qty</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {books.map((row, index) => {
                      if (row.title === selectedBook) {
                        return (
                          <TableRow key={index}>
                            <TableCell>{row.date}</TableCell>
                            <TableCell>
                              {row.profitPaperBack &&
                                row.profitPaperBack.toFixed(2)}
                            </TableCell>
                            <TableCell>{row.profitAmazonKindle}</TableCell>
                            <TableCell>{row.paperBackAmazon}</TableCell>
                            <TableCell>{row.paperBackFlipkart}</TableCell>
                            <TableCell>{row.nexusStore}</TableCell>
                            <TableCell>{row.paperBackTotal}</TableCell>
                            {/* <TableCell>{row.paperBackProfitEarned && row.paperBackProfitEarned.toFixed(2)}</TableCell> */}
                            <TableCell>{row.kindleOverseas}</TableCell>
                            <TableCell>{row.kindleAmazonIn}</TableCell>
                            <TableCell>{row.kindleTotalQty}</TableCell>
                            {/* <TableCell>{row.kindleProfitEarnings}</TableCell> */}
                            <TableCell>{row.grandTotal}</TableCell>
                          </TableRow>
                        );
                      }
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <div
                style={{
                  marginTop: "20px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                (NOTE - Min. Earning cut-off Amount Rs. 1,000/- for Payout
                subject to keeping some security amount with NSP, for the
                purpose of if return initiated by the buyer.) * - T & C Applied.
                Please feel free to contact us if you have any issues.
              </div>
            </div>
          </Container>
        </main>
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default UsersScreen;
